// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__1kc6Y","question":"Question_question__KEl9S","description":"Question_description__3Mr_Q"};